import api from "@/shared/services/apiClient";
import type { AppSupportFormData, AppSupportUpdateData, AppSupportAgent } from "@/features/app-support/types/appSupport";

export const appSupportService = {
  searchTickets: async (filters: Record<string, any> = {}) => {
    const cleanFilters: Record<string, any> = {};
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== "All" && value !== "") {
        cleanFilters[key] = value;
      }
    });
    const response = await api.get("/app-support/search", { params: cleanFilters });
    return response.data;
  },

  getTicket: async (ticketId: number) => {
    const response = await api.get(`/app-support/${ticketId}`);
    return response.data;
  },

  createTicket: async (formData: AppSupportFormData) => {
    const payload = {
      ...formData,
      browser_info: formData.browser_info ?? navigator.userAgent,
    };
    const response = await api.post("/app-support/create", payload);
    return response.data;
  },

  updateTicket: async (ticketId: number, data: AppSupportUpdateData) => {
    const response = await api.put(`/app-support/update/${ticketId}`, data);
    return response.data;
  },

  deleteTicket: async (ticketId: number) => {
    const response = await api.delete(`/app-support/delete/${ticketId}`);
    return response.data;
  },

  getSupportAgents: async (): Promise<AppSupportAgent[]> => {
    try {
      const response = await api.get("/app-support/agents");
      return Array.isArray(response.data) ? response.data : [];
    } catch {
      return [];
    }
  },
};
